/* eslint-disable max-lines */
/* eslint-disable max-len */
export const response = {
  message: 'OK',
  code: 200,
  data: [
    {
      status: 101,
      updateTime: '2019-07-24T05:01:02.131184+00:00',
      processorReply: null,
      achData: null,
      invoices: [
        {
          totalPrice: 15488.4,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/7890',
          createTime: '2019-07-24T17:01:37.247192+00:00',
          formUrlKey: 'd9a5ad42-a1e0-464d-999e-bda50ebcc0fa',
          clientSource: '2',
          formTplId: 359,
          id: 552700,
          formEditUrl:
            'http://console.vista.studio/forms/xcharterjs/edit/?d9a5ad42-a1e0-464d-999e-bda50ebcc0fa',
          invoicePaymentStatus: 4,
          formUrl:
            'http://console.vista.studio/forms/xcharterjs/?d9a5ad42-a1e0-464d-999e-bda50ebcc0fa',
        },
        {
          totalPrice: 15488.4,
          orderPaymentStatus: -1,
          createTime: '2019-07-24T20:30:57.861545+00:00',
          formUrlKey: 'eaf097bf-ec2f-4c43-a346-843cb999d5ae',
          clientSource: '2',
          formTplId: 361,
          id: 552710,
          formEditUrl:
            'http://console.vista.studio/forms/xcharterjs_mod/edit/?eaf097bf-ec2f-4c43-a346-843cb999d5ae',
          invoicePaymentStatus: 2,
          formUrl:
            'http://console.vista.studio/forms/xcharterjs_mod/?eaf097bf-ec2f-4c43-a346-843cb999d5ae',
        },
      ],
      orderItemTotal: 15488.4,
      invoiceData: null,
      departureDate: '2019-08-16T12:00:00',
      assignedOperator: 2040155,
      total: '15480',
      requestText:
        '{"aviData":{"refurb":2013,"rating":4,"notes":["2019-08-16T14:36:00-05:00"],"aoc":{"number":"V6NA918J","holder":"Hop-A-Jet World Wide Jet Charter, Inc"},"btime":156,"tailNumber":"N296L","refurb_int":2018,"sched_raw":"2019-01-29T04:31:05.000Z","yom":2005,"sched":0},"taxes":{"fetTax":1080,"segmentFees":0},"safety_rating":{"wyvernSafety":"Wingman","argusSafety":"Platinum"},"className":"Mid Size Jets","sFtime":"02:35","yom":2005,"src":"avinode","rebate":{"perSeatRebatePrice":2400,"description":"Select the number of seats needed and we’ll invite fellow fliers to purchase your extra seats. For every seat sold, you will be automatically reimbursed in flight credit.\\nNote: JetSmarter collects a 15% fee of total seat sales.\\nThis flight price is not guaranteed. Your potential rebate amount may change once this flight price is confirmed by one of our charter sales managers."},"amenity":"110V Outlet|AirShow|CD player|DataPort|DVD player|Enclosed lavatory|Freon air conditioning|Leather seats|Microwave oven|Other phone|Oven|Partial galley|Pets allowed|Power outlet|Smoking allowed","ftime":155,"fstops":0,"fstops_seg_max":0,"canUseAdditionalAccountModel":true,"showPriceAlert":true,"rebateRequested":{},"allowedForNonMembers2":true,"insurance":200000000,"additionalAccountModel":[{"paymentHeader":"FLIGHT CREDIT","paymentDescription":"You can use your available flight credit to pay for up to 25% (or up to $3,000) of the flight cost. Shuttle tokens and flight credit cannot be combined.\\n_link here_ \\nYour current flight credit balance is $15,000. ","linkUrl":"https://jetsmarter.com/app/v6/legal/flight-rebate-credit-policy/","accountId":1,"maxAmountPercentage":0.25,"maxAmount":3000,"doNotAllowSimultaneously":[3,4,5],"linkTitle":"Flight credits utilization policy","dontAllowTokens":true,"purchaseBtnPrefix":"FC"}],"allowedForNonMembers":true,"price":14400,"nonMemberPrice":15700,"guaranteed":0,"priceAlertText":"Create an alert, and we’ll let you know if the cost of the %@ → %@ %@ flight on %@ drops below your set price.","ftime_seg_max":155,"optionId":116830511,"img":["https://media-content.avinode.com/mediafiles/store/563/635176873051196279_26.jpg","https://media-content.avinode.com/mediafiles/store/563/hpicak4p.gxa.jpg","https://media-content.avinode.com/mediafiles/store/563/130366022522271191_26.jpg"],"itinerary":[{"origin":"KFLL","destination":"KTEB","departing":"2019-08-16T17:00:00Z","arrivingLocal":"2019-08-16T14:36:00-05:00","departingLocal":"2019-08-16T12:00:00-05:00","flightTimeMinutes":155,"estimatedFuelStops":0}],"img2":{"floorplan":"https://media-content.avinode.com/mediafiles/store/563/130366022522271191_26.jpg","exterior":"https://media-content.avinode.com/mediafiles/store/563/635176873051196279_26.jpg","interior":"https://media-content.avinode.com/mediafiles/store/563/hpicak4p.gxa.jpg"},"notesId":114,"blockFlightCreditUse":true,"reqLegData":[{"depart":"KFLL","arrive":"KTEB","time":"2019-08-16T12:00"}],"title":"Learjet 60","pax":7,"membershipAtPurchase":44,"membershipPeriodAtPurchase":1007242,"deviceType":1,"flightLines":[{"CHARTER PRICE:":"$14400"},{"SUBTOTAL:":"$14400"},{"FET TAX (7.5%):":"$1080"},{"TOTAL:":"$15480"}],"flightCredits":0,"rebateCredits":0,"createCredits":0,"sophCredits":0,"promoCredits":0,"additionalAccounts":[],"origRequest":{"legFwd":336514,"legIDs":[336514]}}',
      cardTransactionId: null,
      comments: null,
      searchParamsSeqment: 'KFLL.KTEB.19.08.16.12.00',
      state: 14,
      production: false,
      pricingException: null,
      isValid: true,
      requestId: 12713051,
      invoiceState: 2,
      searchParams:
        '{"pax":2,"currency":"USD","seg":["KFLL.KTEB.19.08.16.12.00"],"version":"APP6.16.1(4)","fuelStops":99}',
      recepientId: null,
      requestUrl: 'http://console.vista.studio/#fl:12713051',
      requestTime: '2019-07-23T19:07:28.335448+00:00',
      requestTypeId: 1,
      charterAction: 6,
      requestedByClient: 1703838,
      clientId: 1703838,
      remoteIp: null,
    },
  ],
};
